<template>
    <!-- begin:: Header -->
    <header class="ct-header ct-header-fixed">
        <!-- begin:: Header Topbar -->
        <nav class="navbar navbar-expand-sm navbar-light w-100 flex-nowrap" :class="clsLeftBordered">
            <div class="d-flex align-items-center">
                <!--
                showtop {{hasNavTopMenu}}<br />
                comparacao {{(hasNavTopMenu && hasMainSidebarSlot)}}<br />
                hasslot {{hasMainSidebarSlot}}<br />
                -->
                <button class="navbar-toggler-sidebar" :class="classToggler" type="button" data-toggle="collapse"
                    data-target="" aria-controls="" aria-expanded="false"
                    aria-label="Toggle sidebar" @click="toggleMenuSideBar()">
                    <span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span>
                </button>
                 <router-link
                    :to="{ name: initialPagePlatform }"
                    class="navbar-brand py-0 ml-sm-2 mr-0 mr-md-2"
                    :class="{'d-lg-none': $route.meta.hideHeaderName}"
                >
                    <div class="row no-gutters">
                        <div class="col-auto">
                            <template v-if="hasNavTopMenu">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header.svg')" class="d-none d-lg-block only-img">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-tablet.svg')" class="d-none d-sm-block d-lg-none only-img">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-mobile.svg')" class="d-block d-sm-none only-img">
                                <h6 class="text-nowrap d-block d-sm-none m-0 module-name" v-if="moduleName">{{ moduleName }}</h6>
                            </template>
                            <template v-else>
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header.svg')" class="d-none d-lg-block">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-tablet.svg')" class="d-none d-sm-block d-lg-none">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-mobile.svg')" class="d-block d-sm-none">
                                <h6 class="text-nowrap m-0 module-name" v-if="moduleName">{{ moduleName }}</h6>
                            </template>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="navbar-collapse justify-content-between align-items-center w-auto w-sm-100">
                <div class="navbar-nav text-center" :class="{'mx-auto': !activeSearchPortal, 'navbar--portal': activeSearchPortal}">
                    <SearchBox
                        v-if="activeSearchPanel"
                        :moduleCode="moduleCode"
                        key="search-box"
                        class="d-none d-sm-inline-block" />
                    <SearchAdvanced
                        v-if="activeAdvancedSearchPanel"
                        :moduleCode="moduleCode"
                        :eventAdvancedSearch="eventAdvancedSearchPanel"
                        key="search-advanced" />
                </div>
                <div class="nav navbar-nav flex-row justify-content-end flex-nowrap">

                    <!-- TOOLS -->
                    <template v-for="tool in tools">
                        <component
                            :is="`${tool.component}HeaderTool`"
                            :key="`header-tool-${tool.component}`"
                            :title="tool.title ? $t(tool.title) : tool.title"
                            :moduleCode="moduleCode"
                            :propIdPanel="tool.id ?? tool.component"
                            :hasNavTopMenu="hasNavTopMenu"
                            :class="tool.cls ?? tool.class">
                        </component>
                    </template>

                    <!-- USER -->
                    <div class="dropdown">
                        <template v-if="$auth.check()">
                            <!-- d-flex align-items-center justify-content-center -->
                            <a
                                href="#"
                                role="button"
                                class="header-icon"
                                id="dropdownMenuUser"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                aria-haspopup="true">
                                <div class="media topbar-user">
                                    <img :src="($auth.user().photo ? $auth.user().photo : avatar)"
                                        class="align-self-center profile-image ml-1 ml-sm-2 ml-md-3"
                                        :title="[$auth.user().name]"
                                        data-toggle="tooltip-city"
                                        :alt="$auth.user().name">
                                    <div class="media-body align-self-center"
                                        :title="$t(`auth.user.menu`)"
                                        data-toggle="tooltip-city">
                                        <div class="d-none d-md-flex flex-column text-left p-0 ml-2">
                                            <span class="d-inline-block text-welcome">
                                                {{ $t(`auth.user.prefix-name-welcome`) }}
                                            </span>
                                            <span class="d-inline-block text-username text-truncate text-truncate-header">
                                                {{$auth.user().name}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-animated dropdown-lg" aria-labelledby="dropdownMenuUser" x-placement="bottom-start">
                                <div class="dropdown-header bg-trans-gradient d-flex flex-row py-3 rounded-top">
                                    <div class="d-flex flex-column flex-fill align-items-start mt-1 mb-1 text-white">
                                        <div class="mb-2 mx-auto">
                                            <img :src="($auth.user().photo ? $auth.user().photo : avatar)" class="rounded-circle profile-image" :alt="$auth.user().name">
                                        </div>
                                        <div class="info-card-text">
                                            <div class="text-truncate text-truncate-lg">{{ $auth.user().name }}</div>
                                            <span class="text-truncate text-truncate-md opacity-80">{{ $auth.user().email }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dropdown-divider m-0"></div>
                                <router-link
                                    v-if="hasAccess('portal.profile')"
                                    :to="{ name: 'portal.profile' }"
                                    class="dropdown-item"
                                    data-toggle="modal"
                                    data-target="">
                                    <span data-i18n="">{{ $t(`auth.profile`) }}</span>
                                </router-link>
                                <div class="dropdown-divider m-0"></div>
                                <router-link
                                    v-if="hasAccess('portal.dashboard')"
                                    :to="{ name: 'portal.dashboard' }"
                                    class="dropdown-item"
                                    data-toggle="modal"
                                    data-target="">
                                    <span data-i18n="">{{ $t(`dashboard.title`) }}</span>
                                </router-link>
                                <div class="dropdown-divider m-0"></div>
                                <router-link
                                    :to="{ name: 'portal.logout' }"
                                    class="dropdown-item fw-500 pt-3 pb-3"
                                    data-toggle="modal"
                                    data-target="">
                                    <span data-i18n="">{{ $t(`auth.actions.logout`) }}</span>
                                    <span class="float-right fw-n">@cityhub</span>
                                </router-link>
                            </div>
                        </template>
                        <template v-else>
                            <router-link
                                :to="{ name: 'portal.login' }"
                                :title="$t(`auth.actions.login`)"
                                class="header-icon m-0 p-0" >
                                <div class="media topbar-user">
                                    <img :src="loginIcon"
                                        class="align-self-center"
                                        :alt="$t(`auth.actions.login`)">
                                    <div class="media-body align-self-center">
                                        <div class="d-none d-md-flex flex-column text-left p-0 ml-2">
                                            <span class="d-inline-block text-welcome font-small">{{ $t(`auth.actions.login`) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>

        </nav>
        <!-- end:: Header Topbar -->
    </header>
    <!-- end:: Header -->
</template>

<script>
    import { toCamelCase, toSnakeCase } from "@config/utils";
    import GlobalMixin from '@/app/shared/mixins/global';
    import defaultAvatar from '@images/avatar.png';
    import LoginIcon from '@images/icons/login.svg';
    // import Cloud from '@images/icons/cloud.svg';
    // import CloudCheck from '@images/icons/cloud-check.svg';
    // import CloudCross from '@images/icons/cloud-cross.svg';
    // import CloudError from '@images/icons/cloud-error.svg';
    // import CloudRemoteWorking from '@images/icons/cloud-remote-working.svg';
    // import CloudSync from '@images/icons/cloud-sync.svg';
    // import CloudUnavailable from '@images/icons/cloud-unavailable.svg';


    export default {
        components: {
            SearchBox: () => import(/* webpackChunkName: "search-box" */ './NavSearchBox'),
            SearchPortal: () => import(/* webpackChunkName: "search-portal" */ './NavSearchPortal'),
            SearchAdvanced: () => import(/* webpackChunkName: "search-advanced" */ './NavSearchAdvanced'),
            ActivityHeaderTool: () => import(/* webpackChunkName: "activity-header-tool" */ './components/activityHeaderTool'),
            OverdueHeaderTool: () => import(/* webpackChunkName: "overdue-header-tool" */ './components/overdueHeaderTool'),
            DashboardHeaderTool: () => import(/* webpackChunkName: "dashboard-header-tool" */ './components/dashboardHeaderTool'),
            AccountableHeaderTool: () => import(/* webpackChunkName: "accountable-header-tool" */ './components/accountableHeaderTool'),

            BroadcastingInitializedHeaderTool: () => import(/* webpackChunkName: "broadcasting-header-tool" */ './components/broadcasting/broadcastingInitialized'),
            BroadcastingConnectingHeaderTool: () => import(/* webpackChunkName: "broadcasting-header-tool" */ './components/broadcasting/broadcastingConnecting'),
            BroadcastingConnectedHeaderTool: () => import(/* webpackChunkName: "broadcasting-header-tool" */ './components/broadcasting/broadcastingConnected'),
            BroadcastingFailedHeaderTool: () => import(/* webpackChunkName: "broadcasting-header-tool" */ './components/broadcasting/broadcastingFailed'),
            BroadcastingUnavailableHeaderTool: () => import(/* webpackChunkName: "broadcasting-header-tool" */ './components/broadcasting/broadcastingUnavailable'),
            BroadcastingDisconnectedHeaderTool: () => import(/* webpackChunkName: "broadcasting-header-tool" */ './components/broadcasting/broadcastingDisconnected'),
        },
        mixins: [
            GlobalMixin,
        ],
        props: {
            hasMainSidebarSlot: {
                type: Boolean,
                default: false
            },
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            showBorderTopLeft: {
                type: Boolean,
                default: false
            },
            hasNavTopMenu: {
                type: Boolean,
                default: false
            },
            activeSearchPortal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                pageID: 'headernav',
                idPanelSearch: 'navsearch',
                idPanelAdvancedSearch: 'navsearch_advanced',
            }
        },
        computed: {
            avatar() {
                return defaultAvatar;
            },
            loginIcon() {
                return LoginIcon;
            },
            broadcastingPanelConfig() {
                return this.$store.getters.getStateTool(this.moduleCode, 'broadcasting') ?? {};
            },
            broadcastingPanelActive() {
                return this.broadcastingPanelConfig?.active ?? false;
            },
            broadcastingEnabled() {
                return this.$store.getters.broadcastingEnabled ?? false;
            },
            broadcastingState() {
                return this.$store.getters.broadcastingState ?? null;
            },
            broadcastingStateClass() {
                let cls = '';
                if(this.broadcastingState) {
                    switch (this.broadcastingState.toLowerCase()) {
                        case "initialized":
                            break;
                        case "connecting":
                            cls = "text-warning";
                            break;
                        case "connected":
                            cls = "text-success";
                            break;
                        case "unavailable":
                            cls = "text-danger";
                            break;
                        case "failed":
                            cls = "text-danger";
                            break;
                        case "disconnected":
                            cls = "text-warning";
                            break;
                        default:
                            break;
                    }
                }
                return cls;
            },
            tools(){
                let tools = [...(typeof this.getPanel === 'function' ? this.getPanel(this.moduleCode, this.pageID)?.tools ?? [] : [])];
                if(this.broadcastingEnabled && this.broadcastingState && this.broadcastingPanelActive) {
                    let _component = `Broadcasting${toCamelCase(this.broadcastingState, true)}`;
                    if(!tools.find(t => t.component == _component)) {
                        tools.unshift({
                            id: `broadcasting-${toSnakeCase(this.broadcastingState)}`,
                            component: _component,
                            title: null,
                            moduleCode: null,
                            cls: this.broadcastingStateClass
                        });
                    }
                }
                return tools;
            },
            classToggler() {
                if (this.hasNavTopMenu && this.hasMainSidebarSlot) return 'd-lg-none';
                if (!this.hasNavTopMenu && this.hasMainSidebarSlot) return 'd-lg-none';
                return 'd-sm-none';
                // return {
                //     'd-sm-none': !(this.hasNavTopMenu && this.hasMainSidebarSlot),
                //     'd-lg-none': (this.hasNavTopMenu && this.hasMainSidebarSlot)
                // }
            },
            moduleName(){
                return this.$store.getters.getModuleName(this.moduleCode);
            },
            getPanel(){
                return this.$store.getters.getPanel;
            },
            clsLeftBordered () {
              return this.showBorderTopLeft ? 'left-bordered' : '';
            },
            activeSearchPanel() {
                return this.checkPermissionPanel(this.$store.getters.getStateTool(this.moduleCode, this.idPanelSearch), this.idPanelSearch);
            },
            activeAdvancedSearchPanel() {
                return this.checkPermissionPanel( this.$store.getters.getStateTool(this.moduleCode, this.idPanelAdvancedSearch), this.idPanelAdvancedSearch);
            },
            eventAdvancedSearchPanel() {
                return (this.$store.getters.getPanel(this.moduleCode, this.idPanelAdvancedSearch) ?? {}).event;
            },
        },
        methods: {
            hasAccess(routeName) {
                const profileRoute = this.$router.getRoutes().find((route) => {
                    return route.name == routeName;
                });
                if(profileRoute.meta.auth == undefined) {
                    return true;
                }
                return this.$auth.check(profileRoute.meta.auth.roles[0]);
            },
            openPanel(id){
                return this.$store.dispatch(`${this.moduleCode}/openPanel`, id);
            },
            toggleMenuSideBar () {
                this.$emit('toggleClick');
            },
            logout: function() {
                this.$router.push({ name: `portal.logout` })
            },
        },
    }
</script>

<style scoped lang="scss">
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";

.theme-switch {
    background-color: $body-bg-color !important;
}

.ct-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: relative;
    z-index: $zindex-main-header;
    height: $navbar-header-height;
    @include sm {
        height: $navbar-header-height-sm;
    }
    .navbar {
        .navbar-toggler-sidebar {
            color: $navbar-module-name-color;
            @include sm {
                color: $navbar-module-name-color-sm;
            }
        }

        .navbar-brand {
            white-space: normal;

            .module-name {
                line-height: 1.45;
                font-size: 0.7rem;
                text-transform: $navbar-module-name-text-transform;
                font-family: $navbar-module-name-font;
                color: $navbar-module-name-color;
                @include sm {
                    font-size: 0.8rem;
                    color: $navbar-module-name-color-sm;
                }
            }

            img {
                max-width: 155px;
                @include sm {
                    max-width: 100%;
                }
                // @include sm {
                //     max-width: 170px;
                // }
                // @include md {
                //     max-width: 250px;
                // }
                // @include lg {
                //     max-width: 100%;
                // }
            }

            @include lg {
                img.only-img {
                    max-width: 350px;
                }
            }
            @include xl {
                img.only-img {
                    max-width: 430px;
                }
            }

            @include xxl {
                img.only-img {
                    max-width: 550px;
                }
            }
        }
    }

    &.ct-header-fixed {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: $zindex-main-header;
        // z-index: inherit;
    }
}



/* @media (min-width: 576px){ */
@include sm {
    .ct-header {
        background-color: $side-menu-bg-color;
        // border-bottom: 1px solid #eff0f6;
        @include sm {
            background-color: $navbar-header-bg-color-sm;
        }
        @media (min-width: 1025px) {
            background-color: $navbar-header-bg-color;
        }

        .ct-header-mobile {
            display: none;
        }

        // &.ct-header-fixed {
        //     position: fixed;
        //     top: 0;
        //     right: 0;
        //     left: 0;
        //     z-index: $zindex-main-header;
        //     // z-index: inherit;
        // }
    }
    .module-portal {
        .ct-header {
            &.ct-header-fixed {
                z-index: $zindex-main-header;
            }
        }
    }
}
@media (max-width: 1024px){
    .ct-header-mobile{

    }
}
@media (min-width: 1025px){
    .ct-header {

        .navbar-toggler-sidebar {
            display: none;
        }

        // &.ct-header-fixed {
        //     position: fixed;
        //     top: 0;
        //     right: 0;
        //     left: 0;
        //     z-index: $zindex-main-header;
        // }
    }

    .ct-header-fixed:not(.ct-aside-only-mobile) {
        .ct-header {
            &.ct-header-fixed {
                left: $navbar-sidebar-width;
            }
        }
    }
}
</style>

<style lang="scss">
@import "@styles/bootstrap/_mixins.scss";
@import "@styles/_theme.scss";
@include media-breakpoint-down(sm) {
    .ct-content {
        margin-top: $navbar-header-height;
    }
}
</style>
